import debounce from 'hs-lodash/debounce';
import { trackEditorInteraction, getFromToValue } from 'FormsUI/utils/TrackingUtils';
import { UPDATE_GDPR_OPTION, UPDATE_GDPR_PROPERTY, DELETE_GDPR_CHECKBOX, UPDATE_GDPR_CHECKBOX } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
const DEBOUNCE_MS = 1000;
export const trackEvent = (...args) => trackEditorInteraction.apply(null, args);
export const trackUpdateGdprOption = (from, to) => trackEvent(UPDATE_GDPR_OPTION, {
  value: getFromToValue(from, to)
});
export const trackUpdateGdprProperty = value => {
  trackEvent(UPDATE_GDPR_PROPERTY, {
    value
  });
};
export const trackUpdateGdprPropertyDebounced = debounce(trackUpdateGdprProperty, DEBOUNCE_MS);
export const trackUpdateGdprCheckbox = () => trackEvent(UPDATE_GDPR_CHECKBOX);
export const trackDeleteGdprCheckbox = () => trackEvent(DELETE_GDPR_CHECKBOX);